import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.js";
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import SearchNominatim from 'ol-ext/control/SearchNominatim'
import L from "leaflet";

// search using Nominatim
// var search = new SearchNominatim(
//   {	//target: $(".options").get(0),
//       title: "Orte suchen",
//       placeholder: "Orte suchen",
//       polygon: true,
//       reverse: false,
//       maxItems: 0,
//       bounded: true,
//       // restrict search in OSM to Germany-bbox
//       viewbox: [-5.0, 42.5, 25.3, 58],
//       position: true,	// Search, with priority to geo position
//   });

// https://github.com/jonataswalker/ol-geocoder

export default function LeafletControlGeocoder() {
  const map = useMap();

  useEffect(() => {
    // var geocoder = new Geocoder('nominatim', {
    //   provider: 'mapquest',
    //   key: '__some_key__',
    //   lang: 'pt-BR', //en-US, fr-FR
    //   placeholder: 'Search for ...',
    //   targetType: 'text-input',
    //   limit: 5,
    //   keepOpen: true
    // });
    // search using Nominatim
    // var search = new SearchNominatim(
    //   {	//target: $(".options").get(0),
    //       title: "Orte suchen",
    //       placeholder: "Orte suchen",
    //       polygon: true,
    //       reverse: false,
    //       maxItems: 0,
    //       bounded: true,
    //       autoComplete: true,
    //       // restrict search in OSM to Germany-bbox
    //       viewbox: [-5.0, 42.5, 25.3, 58],
    //       position: true,	// Search, with priority to geo position
    //   });

    var geocoder = L.Control.Geocoder.nominatim();

    // var geocoder = search
    if (typeof URLSearchParams !== "undefined" && window.location.search) {
      // parse /?geocoder=nominatim from URL
      var params = new URLSearchParams(window.location.search);
      var geocoderString = params.get("geocoder");
      if (geocoderString && L.Control.Geocoder[geocoderString]) {
        geocoder = L.Control.Geocoder[geocoderString]();
      } else if (geocoderString) {
        console.warn("Unsupported geocoder", geocoderString);
      }
    }

    L.Control.geocoder({

      placeholder: "Bundesland/Ort suchen...",
      defaultMarkGeocode: false,
      geocoder: new L.Control.Geocoder.Nominatim({
        geocodingQueryParams: {
          "viewbox": "5.98865807458, 47.3024876979, 15.0169958839, 54.983104153",
          'bounded': 1
        }
      })
    })
      .on("markgeocode", function (e) {
        var latlng = e.geocode.center;
        // L.marker(latlng, { icon })
        //   .addTo(map)
        //   .bindPopup(e.geocode.name)
        //   .openPopup();
        map.fitBounds(e.geocode.bbox);
      })
      .addTo(map);
  }, []);

  return null;
}